import { useState } from 'react';
import QueueSelector from './QueueSelector';
import MetricSelector from './MetricSelector';
import WidgetPreview from './WidgetPreview';
import ThresholdBuilder from './ThresholdBuilder';
import AlertComponent from '../Common/AlertComponent';
import {v4 as uuidv4} from 'uuid';
import {
    Tabs,
    TabList, 
    TabPanels, 
    Tab, 
    TabPanel,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
    Button,
    IconButton

  } from '@chakra-ui/react';
  import { AddIcon } from '@chakra-ui/icons';



function WidgetModal({queues, ccxQueues, boardData, setBoardData, symbeeStats}) {
    
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [error, setError] = useState(false);
    const [errorDesc,setErrorDesc] = useState({body: null, title: null});
    const [tempWidget, setTempWidget] = useState({name: "", arn: [], statistic: [], type: "", thresholds: {}, id: ""});
    
    
    const handleSave = async () => {
        if(tempWidget.name.length < 1){
        setErrorDesc({body: 'You must specify a title', title: 'Missing widget parameters'});
        setError(true);
        return;
      }
      if( boardData.layout.includes(tempWidget.name)){
        setErrorDesc({body: 'Widget title must be unique within this board', title: 'Naming Conflict'});
        setError(true);
        return;
      }
      if(tempWidget.statistic.length < 1){
        setErrorDesc({body: 'You must choose a metric', title: 'Missing widget parameters'});
        setError(true);
        return;
      }
      if(tempWidget.arn.length < 1){
        setErrorDesc({body: 'You must choose at least one queue', title: 'Missing widget parameters'});
        setError(true);
        return;
      }
      if(tempWidget.name.length > 0 && tempWidget.statistic.length > 0 && tempWidget.arn.length > 0 && !boardData.layout.includes(tempWidget.name)){
        setError(false);
      }
      
        let tempBoardData = {...boardData};
        let tempWidgetArray = [...boardData.widgets];
        let tempLayoutArray = [...boardData.layout];
        tempWidget.id = uuidv4();
        tempWidgetArray.push(tempWidget);
        tempLayoutArray.push(tempWidget.id);
        tempBoardData.widgets = tempWidgetArray;
        tempBoardData.layout = tempLayoutArray;
        setBoardData(tempBoardData);
        setTempWidget({name: "", arn: [], statistic: [], type: "", thresholds: {}, id: ""});
      return onClose();

    };
    
    const handleDelete = async () => {
      alert('delete');
      return onClose();

    };

    return (
      <>
        <IconButton marginTop='1em' aria-label='Add Item' icon={<AddIcon />} size='xs' colorScheme='green' onClick={onOpen} />
  
        <Modal closeOnOverlayClick={false} size={'xl'} isOpen={isOpen} onClose={onClose} scrollBehavior='inside'>
          <ModalOverlay />
          <ModalContent minWidth='60vw' maxWidth='60vw' minHeight='50vh' >
            <ModalHeader>Build Widget</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
            {error ? <AlertComponent title={errorDesc?.title} body={errorDesc?.body}/> : null }
              <Tabs>
                <TabList>
                  <Tab>Queue Selction</Tab>
                  <Tab>Metric Selection</Tab>
                  <Tab>Thresholds</Tab>
                </TabList>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                  <TabPanels>

                    <TabPanel>
                      <QueueSelector symbeeStats={symbeeStats} queues={queues} ccxQueues={ccxQueues} setTempWidget={setTempWidget} tempWidget={tempWidget}/>
                    </TabPanel>
                    <TabPanel>
                      <MetricSelector queues={queues} ccxQueues={ccxQueues} symbeeStats={symbeeStats} setTempWidget={setTempWidget} tempWidget={tempWidget}/>
                    </TabPanel>
                    <TabPanel>
                      <ThresholdBuilder setTempWidget={setTempWidget} tempWidget={tempWidget}/>
                    </TabPanel>
                  </TabPanels>
                    <WidgetPreview symbeeStats={symbeeStats} setTempWidget={setTempWidget} tempWidget={tempWidget} queues={queues} ccxQueues={ccxQueues} />
                </div>
              </Tabs>
            
            
                
            </ModalBody>
            <ModalFooter>
            <Button colorScheme='red' mr={3} onClick={handleDelete}>
                Delete
              </Button>
              <Button colorScheme='blue' mr={3} onClick={handleSave}>
                Save
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    );
  }

  export default WidgetModal;